<script setup lang="ts">
  import { computed, type Ref, ref } from 'vue'
  import { useUserStore } from '../../stores/user.ts'
  import { useRoute, useRouter } from 'vue-router'
  import { logout } from '../../api/auth'
  import { useUserContextStore } from '../../stores/userContext.ts'
  import ChangePasswordDialog from './ChangePasswordDialog.vue'
  import { GET_CLINIC } from '../../graphql/queries.ts'
  import { useQuery } from '@vue/apollo-composable'
  
  const store = useUserStore()
  const route = useRoute()
  const router = useRouter()

  const passwordDialog: Ref<boolean> = ref(false)

  const variables = computed(() => ({
    clinicId: Number(route.params.clinicId),
  }))

  const { result } = useQuery(
    GET_CLINIC,
    variables,
  )

  const clinic = computed(() => result.value?.clinic ?? [])

  async function handleLogout() {
    const userStore = useUserStore()
    const userContextStore = useUserContextStore()

    try {
      await logout()
    } finally {
      // Always clear client state
      userStore.clearUser()
      userContextStore.clearPatient()
      router.push('/login')
    }
}

</script>

<template>
<v-app-bar height="54" class="px-4 d-flex align-center overflow-x-auto bg-background" elevation="0" >
    <template v-slot:prepend>

      <v-btn
        v-if="clinic.name"
        color="#112e34"
        prepend-icon="mdi-hospital-marker"
        variant="outlined"
        rounded
        class="mx-1"
        size="small"
        @click="()=> router.push({name: 'clinics'})"
      >
        {{ clinic.name }}
      </v-btn>

      <v-btn
        v-else
        color="transparent"
        prepend-icon="mdi-hospital-marker"
        variant="outlined"
        rounded
        class="mx-1"
        size="small"
      >
        No Clinic Selected
      </v-btn>

    </template>
    <img
       :width="100"
       :max-height="60"
       class="mr-2"
       cover
       src="/res.png"
     />
    <template v-slot:append>
      <v-btn
        color="#112e34"
        prepend-icon="mdi-account-circle"
        variant="outlined"
        rounded
        class="mx-1"
        size="small"
      >
        {{store.currentUser?.firstName}}
          
        <v-menu activator="parent">
          <v-card rounded="lg">
            <v-card width="250" elevation="0" rounded="lg" class="ma-2 pa-4 d-flex flex-column align-center bg-tertiary">
              <v-avatar class="bg-primary">
                <v-icon >mdi-account</v-icon>
              </v-avatar>
              <v-card-title class="mt-1 pb-0">{{store.currentUser?.firstName}}</v-card-title>
              <v-card-subtitle >{{store.currentUser?.email}}</v-card-subtitle>

              <v-btn
                color="primary"
                variant="flat"
                rounded="pill"
                class="text-body-2 mt-6"
                prepend-icon="mdi-key"
                @click="passwordDialog = true"
              >
                Change Password
              </v-btn>
              
            </v-card>
            
          </v-card>
        </v-menu>
      </v-btn>

      <v-btn
        color="#112e34"
        prepend-icon="mdi-logout"
        variant="outlined"
        rounded
        class="mx-2"
        size="small"
        @click="handleLogout"
      >
        logout
      </v-btn>
    </template>
  </v-app-bar>

  <change-password-dialog v-model="passwordDialog"/>

</template>